import { NavLink } from "react-router-dom";
import "./header.css"

export const Header = () => {
  return (
    <header className="header">
      <a href="/" className="myName">JM</a>
      <nav className="menu">
        <ul>
          <li><NavLink to="/">Início</NavLink></li>
          <li><NavLink to="/about-me">Quem sou</NavLink></li>
          <li><NavLink to="/skills">Skills</NavLink></li>
          <li><NavLink to="/projects">Projetos</NavLink></li>
          <li><NavLink to="/contact">Contato</NavLink></li>
        </ul>
      </nav>
    </header>
  );
};
